import { Api } from 'utils';

class IncomeService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/incomes',params),
		save: async (params?: any) => Api.createResponse('admin/incomes/save',params),
		delete: async (params?: any) => Api.createResponse('admin/incomes/delete',params),
		deleteSubcategory: async (params?: any) => Api.createResponse('admin/incomes/delete-subcategory',params),
	}

}

export default IncomeService;